import * as TypeGraphQL from "type-graphql";
export var AssetScalarFieldEnum;
(function (AssetScalarFieldEnum) {
    AssetScalarFieldEnum["id"] = "id";
    AssetScalarFieldEnum["symbol"] = "symbol";
    AssetScalarFieldEnum["name"] = "name";
    AssetScalarFieldEnum["type"] = "type";
    AssetScalarFieldEnum["logoUrl"] = "logoUrl";
    AssetScalarFieldEnum["description"] = "description";
    AssetScalarFieldEnum["cik"] = "cik";
    AssetScalarFieldEnum["exchange"] = "exchange";
    AssetScalarFieldEnum["currency"] = "currency";
    AssetScalarFieldEnum["country"] = "country";
    AssetScalarFieldEnum["sector"] = "sector";
    AssetScalarFieldEnum["industry"] = "industry";
    AssetScalarFieldEnum["address"] = "address";
    AssetScalarFieldEnum["officialSite"] = "officialSite";
    AssetScalarFieldEnum["fiscalYearEnd"] = "fiscalYearEnd";
    AssetScalarFieldEnum["latestQuarter"] = "latestQuarter";
    AssetScalarFieldEnum["marketCapitalization"] = "marketCapitalization";
    AssetScalarFieldEnum["ebitda"] = "ebitda";
    AssetScalarFieldEnum["peRatio"] = "peRatio";
    AssetScalarFieldEnum["pegRatio"] = "pegRatio";
    AssetScalarFieldEnum["bookValue"] = "bookValue";
    AssetScalarFieldEnum["dividendPerShare"] = "dividendPerShare";
    AssetScalarFieldEnum["dividendYield"] = "dividendYield";
    AssetScalarFieldEnum["eps"] = "eps";
    AssetScalarFieldEnum["revenuePerShareTTM"] = "revenuePerShareTTM";
    AssetScalarFieldEnum["profitMargin"] = "profitMargin";
    AssetScalarFieldEnum["operatingMarginTTM"] = "operatingMarginTTM";
    AssetScalarFieldEnum["returnOnAssetsTTM"] = "returnOnAssetsTTM";
    AssetScalarFieldEnum["returnOnEquityTTM"] = "returnOnEquityTTM";
    AssetScalarFieldEnum["revenueTTM"] = "revenueTTM";
    AssetScalarFieldEnum["grossProfitTTM"] = "grossProfitTTM";
    AssetScalarFieldEnum["dilutedEPSTTM"] = "dilutedEPSTTM";
    AssetScalarFieldEnum["quarterlyEarningsGrowthYOY"] = "quarterlyEarningsGrowthYOY";
    AssetScalarFieldEnum["quarterlyRevenueGrowthYOY"] = "quarterlyRevenueGrowthYOY";
    AssetScalarFieldEnum["analystTargetPrice"] = "analystTargetPrice";
    AssetScalarFieldEnum["analystRatingStrongBuy"] = "analystRatingStrongBuy";
    AssetScalarFieldEnum["analystRatingBuy"] = "analystRatingBuy";
    AssetScalarFieldEnum["analystRatingHold"] = "analystRatingHold";
    AssetScalarFieldEnum["analystRatingSell"] = "analystRatingSell";
    AssetScalarFieldEnum["analystRatingStrongSell"] = "analystRatingStrongSell";
    AssetScalarFieldEnum["trailingPE"] = "trailingPE";
    AssetScalarFieldEnum["forwardPE"] = "forwardPE";
    AssetScalarFieldEnum["priceToSalesRatioTTM"] = "priceToSalesRatioTTM";
    AssetScalarFieldEnum["priceToBookRatio"] = "priceToBookRatio";
    AssetScalarFieldEnum["evToRevenue"] = "evToRevenue";
    AssetScalarFieldEnum["evToEbitda"] = "evToEbitda";
    AssetScalarFieldEnum["beta"] = "beta";
    AssetScalarFieldEnum["week52High"] = "week52High";
    AssetScalarFieldEnum["week52Low"] = "week52Low";
    AssetScalarFieldEnum["day50MovingAverage"] = "day50MovingAverage";
    AssetScalarFieldEnum["day200MovingAverage"] = "day200MovingAverage";
    AssetScalarFieldEnum["sharesOutstanding"] = "sharesOutstanding";
    AssetScalarFieldEnum["dividendDate"] = "dividendDate";
    AssetScalarFieldEnum["exDividendDate"] = "exDividendDate";
    AssetScalarFieldEnum["askPrice"] = "askPrice";
    AssetScalarFieldEnum["bidPrice"] = "bidPrice";
    AssetScalarFieldEnum["createdAt"] = "createdAt";
    AssetScalarFieldEnum["updatedAt"] = "updatedAt";
})(AssetScalarFieldEnum || (AssetScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AssetScalarFieldEnum, {
    name: "AssetScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AssetScalarFieldEnum.js.map